import React, { Component } from 'react';
import LoginSession from '../stores/LoginSession';
import ErrorMessage from '../components/ErrorMessage';

export default class SsoCallbackPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error_message: null
    }
  }

  componentDidMount() {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');

    if (!code || code === 'denied') {
      this.setState({
        loading: false,
        error_message: code === 'denied'
          ? 'ผู้ใช้งานปฏิเสธการเข้าสู่ระบบ'
          : 'ไม่พบรหัสยืนยันตัวตน'
      });
      return;
    }

    var self = this;
    LoginSession.ssoLogin(code).then(function () {
      window.location.href = '/documents/mydoc';
    }, function (error) {
      var error_message = 'ไม่สามารถเข้าสู่ระบบได้';
      if (error.response && error.response.data && error.response.data.errors) {
        error_message = error.response.data.errors[0];
      }
      self.setState({
        loading: false,
        error_message: error_message
      });
    });
  }

  render() {
    return (
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6 ml-auto mr-auto text-center">
            {this.state.loading ? (
              <div>
                <h4>กำลังเข้าสู่ระบบ...</h4>
                <p className="text-muted">กรุณารอสักครู่</p>
              </div>
            ) : (
              <div>
                {this.state.error_message && (
                  <ErrorMessage error_message={this.state.error_message} />
                )}
                <a href="/login" className="btn btn-primary mt-3">
                  กลับไปหน้าเข้าสู่ระบบ
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SsoCallbackPage.js